import { Menu, Bell, ArrowLeft } from 'lucide-react';
import logomarkSvg from '../../imports/YN_logomark.svg';

interface AppHeaderProps {
  title: string;
  onMenuClick?: () => void;
  onNotificationClick?: () => void;
  hasNotifications?: boolean;
  showLogo?: boolean;
  showBackButton?: boolean;
}

export function AppHeader({ 
  title, 
  onMenuClick, 
  onNotificationClick, 
  hasNotifications = false,
  showLogo = false,
  showBackButton = false
}: AppHeaderProps) {
  return (
    <header className="sticky top-0 z-50 border-b bg-white shadow-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
        {showBackButton && onMenuClick ? (
          <button 
            onClick={onMenuClick}
            className="flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100 active:bg-gray-200"
            aria-label="Înapoi"
          >
            <ArrowLeft className="h-6 w-6" style={{ color: '#3b0b86' }} />
          </button>
        ) : (
          <div className="w-10" />
        )}

        <div className="flex items-center gap-2">
          {showLogo && (
            <img src={logomarkSvg} alt="" className="h-8 w-8" />
          )}
          <h1 
            className="text-lg font-semibold" 
            style={{ fontFamily: 'var(--font-primary)', color: '#3b0b86' }}
          >
            {title}
          </h1>
        </div>

        <button 
          onClick={onNotificationClick}
          className="relative flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100 active:bg-gray-200"
          aria-label="Notificări"
        >
          <Bell className="h-6 w-6" style={{ color: '#3b0b86' }} />
          {hasNotifications && (
            <span 
              className="absolute right-1 top-1 h-2 w-2 rounded-full" 
              style={{ backgroundColor: '#ff6417' }} 
            />
          )}
        </button>
      </div>
    </header>
  );
}